export const HaloCoreEndpoints = {
  /** Skill origin */
  SkillOrigin: "skill",
  /** Profile origin */
  Profile: "profile",
  /** Stats origin */
  StatsOrigin: "halostats",
  /** Game CMS origin */
  GameCmsOrigin: "gamecms-hacs",
  /** Discovery origin */
  DiscoveryOrigin: "discovery-infiniteugc",

  CommsOrigin: "comms",
  BanProcessorOrigin: "banprocessor",
  SettingsOrigin: "settings",

  /** Service domain */
  ServiceDomain: "svc.halowaypoint.com:443",
};
